import Ccai from '../assets/CaseStudy/ccats.avif'
import Ccats from '../assets/CaseStudy/AIHead.avif'
import sanlms from '../assets/CaseStudy/LMS Case Study.avif'
import sanhrms from '../assets/CaseStudy/HRMSHead.avif'


// features
import jobListing from '../assets/CaseStudy/ai-jobListing.avif'
import candidateProfile from '../assets/CaseStudy/ai-candidateProfiles.avif'
import applicationWorkflow from '../assets/CaseStudy/ai-applicationWorkflow.avif'
import employerConnectivity from '../assets/CaseStudy/ai-employerConnectivity.avif'
import industryHiring from '../assets/CaseStudy/indstryHiring.avif'
import careerPortal from '../assets/CaseStudy/careerPortal.avif'
import hiringPlatform from '../assets/CaseStudy/hiringPlatform.avif'
import talentDatabase from '../assets/CaseStudy/talentDatabase.avif'

import jobRequisition from '../assets/CaseStudy/ats-jobRequistion.avif'
import candidate from '../assets/CaseStudy/ats-centalizedCandidate.avif'
import interview from '../assets/CaseStudy/ats-interviewCoordination.avif'
import pipeline from '../assets/CaseStudy/ats-pipelineVisibility.avif'
import dashboard from '../assets/CaseStudy/dashboard.avif'
import recruitmnetInsights from '../assets/CaseStudy/recruitmentInsights.avif'
import recruitmnetCollabration from '../assets/CaseStudy/recruitmentCollabration.avif'
import applicantTracking from '../assets/CaseStudy/applicantTracking.avif'

import employee from '../assets/CaseStudy/hrms-employeeInformation.avif'
import payslip from '../assets/CaseStudy/hrms-payslipManage.avif'
import hrWorkflow from '../assets/CaseStudy/hrms-hrworkflow.avif'
// import workforce from '../assets/CaseStudy/hrms-workforceVisibility.png'
import noc from '../assets/CaseStudy/noc.avif'
import attendance from '../assets/CaseStudy/attendence.avif'
import payRevision from '../assets/CaseStudy/payRevision.avif'
import increment from '../assets/CaseStudy/increment.avif'
import tds from '../assets/CaseStudy/tds.avif'

// import course from '../assets/CaseStudy/lms-courseManage.png'
import learningContent from '../assets/CaseStudy/lms-LearningContent.avif'
import learnerAccess from '../assets/CaseStudy/lms-learnerAcces.avif'
import trainingDelivery from '../assets/CaseStudy/lms-trainingDelivery.avif'
import sessionControl from '../assets/CaseStudy/sessionControl.avif'
import videoUpload from '../assets/CaseStudy/videoUpload.avif'
import adminApproval from '../assets/CaseStudy/adminApproval.avif'
import centralizedLearning from '../assets/CaseStudy/CentralizedLearning.avif'
import recordedSession from '../assets/CaseStudy/recordSession.avif'

export const ai = {
    id: 'ccai',
    images: Ccats,
    title: 'CareerConnect AI | Digital Job Portal for Industry-Focused Career Opportunities',
    subtitle: 'Job Portal | Career Opportunities | Talent Connectivity',

    services: [
        'UI/UX Design',
        'Platform Development',
        'Job & Candidate Management',
        'Employer Connectivity'
    ],

    content:
        'A digital job platform designed to connect job seekers with employers through structured profiles, job listings, and streamlined application workflows across multiple industries.',
    features: [
        {
            title: 'Job Listings Management',
            image: jobListing,
            content:
                'Provide a centralized platform for publishing and managing job opportunities across multiple industries with structured role descriptions and application workflows.'
        },

        {
            title: 'Professional Candidate Profiles',
            image: candidateProfile,
            content:
                'Enable candidates to create professional profiles that showcase technical skills, certifications, academic qualifications, and project experience for better recruiter visibility.'
        },

        {
            title: 'Application Workflow',
            image: applicationWorkflow,
            content:
                'Streamline the hiring process through organized application submission, status tracking, and simplified communication between candidates and recruiters.'
        },

        {
            title: 'Employer Connectivity',
            image: employerConnectivity,
            content:
                'Connect organizations with qualified talent through a structured recruitment ecosystem designed to improve hiring accessibility and candidate discovery.'
        },
        {
            title: 'Industry-Focused Opportunities',
            image: industryHiring,
            content:
                'Support career opportunities across IT, Embedded Systems, Mechanical, Electrical, and emerging technology sectors through industry-oriented job listings.'
        },

        {
            title: 'Career Opportunity Portal',
            image: careerPortal,
            content:
                'Offer job seekers access to industry-focused career opportunities across IT, Engineering, Embedded Systems, Mechanical, and emerging technology sectors.'
        },

        {
            title: 'Professional Hiring Platform',
            image: hiringPlatform,
            content:
                'Create a scalable recruitment platform that streamlines talent discovery, candidate engagement, and employment connectivity for modern hiring operations.'
        },

        {
            title: 'Centralized Talent Management',
            image: talentDatabase,
            content:
                'Maintain an organized candidate database that enables employers to efficiently search, filter, and manage applicant information for recruitment operations.'
        }
    ],
    caseStudy: {
        problem:
            'Job seekers in technical industries faced challenges discovering relevant opportunities and effectively presenting their skills to recruiters through traditional hiring methods.',

        solution:
            'CareerConnect AI introduced a centralized recruitment platform that connected candidates with employers through structured profiles, job listings, and streamlined hiring interactions.',

        outcome:
            'The platform improved candidate visibility, simplified employer talent discovery, and enabled more efficient hiring connections across industry-focused roles.'
    }
}

export const ats = {
    id: 'ccai-ats',
    images: Ccai,
    title: 'CareerConnect ATS for Recruitment and Staffing Operations',
    subtitle: 'Applicant Tracking | Recruitment Workflow | Staffing Operations',
    services: ['Candidate Tracking', 'Interview Coordination', 'Recruitment Workflow System', 'Analytics Dashboard'],
    content:
        'A modern applicant tracking platform designed to streamline recruitment processes, manage candidate applications, and improve hiring efficiency through structured and organized workflow management.',
    features: [
        {
            title: 'Recruitment Dashboard',
            image: dashboard,
            content:
                'Access a centralized recruitment dashboard to monitor hiring activities, candidate progress, interview schedules, and workflow updates.'
        },

        {
            title: 'Candidate Management',
            image: candidate,
            content:
                'Maintain structured candidate records including profiles, application status, recruitment history, and hiring stage progression.'
        },

        {
            title: 'Job Requisition',
            image: jobRequisition,
            content:
                'Create and manage hiring requirements with role descriptions, department allocation, and recruitment workflow visibility.'
        },

        {
            title: 'Interview Coordination',
            image: interview,
            content:
                'Schedule interviews, manage evaluation stages, and collect recruiter feedback through an organized interview process.'
        },

        {
            title: 'Hiring Pipeline',
            image: pipeline,
            content:
                'Track candidate movement across recruitment stages with clear visibility into application progress and hiring workflows.'
        },

        {
            title: 'Application Tracking',
            image: applicantTracking,
            content:
                'Monitor candidate applications, status updates, and recruitment activities from initial application to final selection.'
        },

        {
            title: 'Recruitment Collaboration',
            image: recruitmnetCollabration,
            content:
                'Enable recruiters and hiring teams to collaborate efficiently through shared hiring workflows and centralized candidate access.'
        },

        {
            title: 'Recruitment Insights',
            image: recruitmnetInsights,
            content:
                'View recruitment metrics and operational summaries to improve hiring coordination and recruitment planning.'
        }
    ],
    caseStudy: {
        problem:
            'Recruitment teams struggled with scattered candidate information, inconsistent interview coordination, and limited visibility into hiring progress, causing delays in recruitment operations.',

        solution:
            'CareerConnect ATS centralized applicant tracking, interview scheduling, and evaluation workflows into a single structured platform that streamlined hiring collaboration across teams.',

        outcome:
            'The organization improved recruitment efficiency, reduced manual coordination efforts, and gained clear visibility into candidate pipelines, enabling faster and more organized hiring decisions.'
    }
}

export const hrms = {
    id: 'hrms',
    images: sanhrms,
    title: 'SAN HRMS | Workforce Management and Employee Lifecycle Administration',
    subtitle: 'Human Resources | Employee Management | Organizational Operations',
    services: ['Employee Records', 'Payslip Management', 'HR Workflow Management', 'Reporting Dashboard'],
    content:
        'A modern HR management platform designed to organize employee records, simplify HR processes, and provide efficient workforce management through a centralized digital system.',
    features: [
        {
            title: 'Employee Onboarding',
            image: hrWorkflow,
            content: 'Streamline employee onboarding processes with centralized profile creation and document management.'
        },
        {
            title: 'Attendance Management',
            image: attendance,
            content: 'Track employee attendance, working hours, and attendance records through an organized HR system.'
        },
        {
            title: 'Payroll & Payslip',
            image: payslip,
            content: 'Automate payroll processing and generate employee payslips with structured salary management.'
        },
        {
            title: 'Employee Information',
            image: employee,
            content: 'Maintain employee records, department details, and organizational information in a centralized platform.'
        },
        {
            title: 'NOC & Document Management',
            image: noc,
            content: 'Manage employee NOC requests and HR-related documents with streamlined approval workflows.'
        },
        {
            title: 'Increment Management',
            image: increment,
            content: 'Handle employee salary increments and compensation updates through structured HR processes.'
        },
        {
            title: 'Pay Revision',
            image: payRevision,
            content: 'Manage pay revision workflows and maintain updated employee salary structures efficiently.'
        },
        {
            title: 'TDS Management',
            image: tds,
            content: 'Track employee tax deductions, TDS records, and compliance-related financial processes.'
        }
    ],
    caseStudy: {
        problem:
            'Organizations faced challenges managing employee information, payroll-related records, and HR documentation through disconnected manual processes.',

        solution:
            'SAN HRMS centralized employee records, payslip management, and HR workflows into a single platform that simplified workforce administration and document handling.',

        outcome:
            'HR teams improved operational organization, reduced administrative effort, and gained better visibility into employee and payroll-related processes.'
    }

}

export const lms = {
    id: 'lms',
    images: sanlms,
    title: 'SAN LMS Empowering Learners with Industry-Relevant Skills for Career Success',
    subtitle: 'Digital Learning | Skill Development | Training Enablement',

    services: [
        'UI/UX Design',
        'Platform Development',
        'Course Management',
        'Learning Content Delivery'
    ],
    content: 'A modern learning management platform designed to manage recorded training sessions, organize learning content, and provide students with a structured, accessible, and user-friendly digital learning experience.',
    features: [
        {
            title: 'Recorded Sessions',
            image: recordedSession,
            content: 'Provide students with seamless access to recorded training sessions and learning videos through a centralized and organized learning management platform.'
        },
        {
            title: 'Learning Content',
            image: learningContent,
            content: 'Upload, organize, and manage structured learning materials, recorded videos, and course-related resources for different training programs.'
        },
        {
            title: 'Student Access',
            image: learnerAccess,
            content: 'Manage secure student login access and provide controlled availability to learning resources, recorded sessions, and course materials.'
        },
        {
            title: 'Video Upload Management',
            image: videoUpload,
            content: 'Allow trainers and administrators to upload educational videos, training recordings, and digital learning resources efficiently.'
        },
        {
            title: 'Admin Approval Workflow',
            image: adminApproval,
            content: 'Enable administrative approval workflows for uploaded training videos before making sessions available to enrolled students.'
        },
        {
            title: 'Session Availability Control',
            image: sessionControl,
            content: 'Control and manage student accessibility to recorded sessions based on approval status and learning content visibility settings.'
        },
        {
            title: 'Centralized Learning Platform',
            image: centralizedLearning,
            content: 'Maintain all recorded learning sessions, training resources, and educational materials within a single organized digital learning environment.'
        },
        {
            title: 'Training Delivery',
            image: trainingDelivery,
            content: 'Enhance digital training experiences through a user-friendly learning platform designed for smooth content delivery and session management.'
        }
    ],
    caseStudy: {
        problem:
            'Training organizations struggled to organize course materials and provide learners with a structured digital learning experience across programs.',

        solution:
            'SAN LMS introduced a centralized learning platform for managing courses, training content, and learner access through an organized and user-friendly environment.',

        outcome:
            'The platform improved content accessibility, streamlined training delivery, and created a more structured learning experience for users.'
    }
}
